import { render, staticRenderFns } from "./RelationFieldMany.vue?vue&type=template&id=8141eca0&"
import script from "./RelationFieldMany.vue?vue&type=script&lang=js&"
export * from "./RelationFieldMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RelationFieldMany.vue"
export default component.exports